import React, { useState, useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

const SAFETY_TIMEOUT_MS = 8000;

// Toggle-кнопка пульта с индикацией обработки: команда применяется не мгновенно
// (бэк подтверждает новое состояние по WS, у «Показать вопрос» — после предстарта),
// поэтому после клика крутим спиннер и блокируем кнопку, пока `on` не дойдёт до
// ожидаемого значения. Таймаут-страховка снимает блокировку, если событие не пришло.
export default function ToggleButton({ on, onLabel, offLabel, onClick }) {
    const [pending, setPending] = useState(false);
    const expectedRef = useRef(null);
    const timerRef = useRef(null);

    const stop = useCallback(() => {
        setPending(false);
        expectedRef.current = null;
        if (timerRef.current) { clearTimeout(timerRef.current); timerRef.current = null; }
    }, []);

    useEffect(() => {
        if (pending && expectedRef.current === on) {
            console.info('[demo-toggle]', offLabel, '| WS подтвердил on=', on, '→ снимаю pending'); // DEBUG (убрать после диагностики)
            stop();
        }
    }, [on, pending, stop, offLabel]);

    useEffect(() => () => { if (timerRef.current) clearTimeout(timerRef.current); }, []);

    const handleClick = () => {
        if (pending) return;
        expectedRef.current = !on;
        setPending(true);
        console.info('[demo-toggle]', offLabel, '| клик: on=', on, '→ жду on=', !on); // DEBUG (убрать после диагностики)
        timerRef.current = setTimeout(() => {
            console.warn('[demo-toggle]', offLabel, '| таймаут: WS-подтверждение не пришло за', SAFETY_TIMEOUT_MS, 'мс'); // DEBUG
            stop();
        }, SAFETY_TIMEOUT_MS);
        Promise.resolve(onClick())
            .then(() => console.info('[demo-toggle]', offLabel, '| POST ответил (200)')) // DEBUG
            .catch((e) => { console.warn('[demo-toggle]', offLabel, '| POST ошибка:', e?.message || e); stop(); }); // DEBUG
    };

    const cls = `cbtn tg${on ? ' on' : ' cbtn-green'}${pending ? ' pending' : ''}`;
    return (
        <button type="button" className={cls} disabled={pending} onClick={handleClick}>
            {pending && <span className="cbtn-spin" aria-hidden="true" />}
            {on ? onLabel : offLabel}
        </button>
    );
}

ToggleButton.propTypes = {
    on: PropTypes.bool.isRequired,
    onLabel: PropTypes.string.isRequired,
    offLabel: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
};
